import request from '@/util/request';
import qs from 'qs';

// 字典
export const getDictionary = (params, options) =>
    request.get('/api/blade-system/dict/dictionary', Object.assign({}, options, { params }))

// 维保设备列表
export const getDeviceQueryList = (params, options) =>
    request.get('/api/device/queryList', Object.assign({}, options, { params }))
// 设备部件列表
export const getDevicepartQueryList = (params, options) =>
    request.get('/api/devicepart/queryList', Object.assign({}, options, { params }))
// 获取设备巡检标准
export const getDeviceInspectStandard = (params, options) =>
    request.get('/api/deviceinspectstandard/getStandardByDeviceId', Object.assign({}, options, { params }))
// 获取服务类型列表
export const modulesSetting = (projectId) =>
    request.get('/api/v4ward/out/order/setting/modules/' + projectId)
// 获取服务类型列表屏蔽巡检维保区域
export const modulesSetting2 = (projectId) =>
    request.get('/api/v4ward/ordersetting/setting/save/order/modules/' + projectId)
// 查询是否需要经纬度
export const settingPositionflag = (params, options) =>
    request.get('/api/v4ward/ordersetting/setting/positionflag', Object.assign({}, options, { params }))
export const getServiceCommunityList = (params, options) =>
    request.get('/api/v4ward/out/order/service/community/list', Object.assign({}, options, { params }))
   